import { baseTheme, updateTheme } from '.';
import { flattenTheme } from './utils';
import { FLATTEN_CATEGORY } from './constant';
export var getDlsStandard2Theme = function getDlsStandard2Theme(newTheme) {
  var flatTheme = flattenTheme(updateTheme(baseTheme, newTheme));
  var fontFamily = {
    primary: 'Lato, Adobe Heiti Std, Segoe UI, Trebuchet MS, sans-serif',
    secondary: 'Museo-500, Georgia, Times New Roman, Times, serif'
  };
  var componentsTheme = {
    button: {
      minWidth: '128px',
      minHeight: '40px',
      border: '1px solid transparent',
      borderRadius: flatTheme.rad_xl,
      padding: "".concat(flatTheme.space_2, "px ").concat(flatTheme.space_6, "px"),
      background: flatTheme.cl_pri_base,
      hoverBg: flatTheme.cl_pri_d2,
      activeBg: flatTheme.cl_pri_d4,
      mdMinHeight: '46px',
      secondary: {
        background: flatTheme.cl_sec_l2,
        borderColor: '1px solid transparent',
        color: flatTheme.cl_sec_d1,
        hoverBg: flatTheme.cl_sec_l1,
        activeBg: flatTheme.cl_sec_base
      },
      small: {
        fontSize: '16px',
        minHeight: '32px',
        minWidth: '120px',
        padding: "4px 16px",
        borderWidth: '1px',
        borderRadius: '12px',
        md: {
          minHeight: '32px',
          minWidth: '120px',
          padding: "4px 16px"
        }
      }
    },
    text: {
      bannerTitle: {
        fontFamily: fontFamily.secondary,
        fontSize: [40, 40, 40, 48, 48],
        lineHeight: 1.2
      },
      pageTitle: {
        fontFamily: fontFamily.primary,
        fontWeight: 900,
        fontSize: [32, 32, 32, 40, 40],
        lineHeight: 1.2
      },
      sectionTitle: {
        fontFamily: fontFamily.primary,
        fontWeight: 900,
        fontSize: [24, 24, 24, 32, 32],
        lineHeight: 1.2
      },
      header: {
        fontFamily: fontFamily.primary,
        fontWeight: 700,
        fontSize: [20, 20, 20, 24, 24],
        lineHeight: 1.25,
        letterSpacing: ['0.01em', '0.01em', '0.01em', 0, 0]
      },
      boldBody: {
        fontFamily: fontFamily.primary,
        fontWeight: 700,
        fontSize: [16, 16, 16, 18, 18],
        lineHeight: 1.5,
        letterSpacing: '0.02em'
      },
      body: {
        fontFamily: fontFamily.primary,
        fontWeight: 400,
        fontSize: [16, 16, 16, 18, 18],
        lineHeight: 1.5,
        letterSpacing: '0.01em'
      },
      smallBody: {
        fontFamily: fontFamily.primary,
        fontWeight: 400,
        fontWeightSemiBold: 600,
        fontSize: [12, 12, 12, 14, 14],
        lineHeight: 1.5,
        letterSpacing: ['0.03em', '0.03em', '0.03em', '0.02em', '0.02em'],
        letterSpacingSemiBold: ['0.03em']
      },
      boldSmallBody: {
        fontFamily: fontFamily.primary,
        fontWeight: 700,
        fontSize: [12, 12, 12, 14, 14],
        lineHeight: 1.5,
        letterSpacing: '0.03em'
      },
      link: {
        fontFamily: fontFamily.primary,
        fontWeight: 700,
        fontSize: [16, 16, 16, 18, 18],
        lineHeight: 1.5,
        letterSpacing: '0.02em'
      }
    },
    inputText: {
      height: [64, 64, 64, 72, 72],
      fontFamily: fontFamily.primary,
      fontSize: [16, 16, 16, 18, 18],
      fontSizeHint: [12, 12, 12, 14, 14],
      fontWeightHint: 600,
      fontWeightFormInput: 400,
      heightFormInput: [24, 24, 24, 27, 27],
      padding: ['29px 16px 11px', '29px 16px 11px', '29px 16px 11px', '33px 16px 12px', '33px 16px 12px'],
      topLabelText: '35px',
      colorHintText: baseTheme.main.colours.tertiary.l3,
      caretColor: baseTheme.main.colours.secondary.d1
    },
    hintText: {
      fontFamily: fontFamily.primary,
      fontSize: [12, 12, 12, 14, 14]
    },
    dropDownInput: {
      fontFamily: fontFamily.primary,
      fontSize: [16, 16, 16, 18, 18],
      fontWeight: 400,
      topIconWrapper: '23px',
      color: baseTheme.main.colours.tertiary
    },
    checkBoxInput: {
      fontFamily: fontFamily.primary,
      fontSize: [16, 16, 16, 18, 18],
      width: 24,
      height: 24,
      paddingLeft: 8,
      hoverXS: 8,
      hoverXL: 7
    },
    radioInput: {
      fontFamily: fontFamily.primary,
      fontSize: [16, 16, 16, 18, 18],
      width: 38,
      height: 38,
      padding: 7,
      marginRight: 8,
      widthInputRadio: 24,
      heightInputRadio: 24,
      marginLabel: '16px 0',
      borderRadioButtonEffect: 6,
      topRadioButtonEffect: 7,
      leftRadioButtonEffect: 7,
      widthRadioButtonEffect: 24,
      heightRadioButtonEffect: 24
    },
    quantityInput: {
      fontFamily: fontFamily.primary,
      fontSize: [16, 16, 16, 18, 18],
      fontWeight: 700,
      height: 24,
      width: 24
    },
    fileInput: {
      fontFamily: fontFamily.primary,
      fontSize: [16, 16, 16, 16],
      fontSizeLabelText: [12, 12, 12, 12, 12],
      fontWeightLabelText: 600
    },
    iconButton: {
      fontFamily: fontFamily.primary,
      fontSize: [12, 12, 12, 12, 12],
      fontWeight: 700
    },
    calendar: {
      fontFamily: fontFamily.primary,
      fontSize: [16, 16, 16, 18, 18]
    },
    otpPinInput: {
      fontFamily: fontFamily.primary,
      fontSize: [16, 16, 16, 18, 18],
      height: [64, 64, 72, 72, 72]
    }
  };
  Object.keys(newTheme || {}).forEach(function (key) {
    if (key in componentsTheme) {
      componentsTheme[key] = Object.assign({}, componentsTheme[key], newTheme[key]);
      delete newTheme[key];
    }

    if (FLATTEN_CATEGORY.includes(key)) {
      delete newTheme[key];
    }
  });
  return Object.assign({}, flatTheme, componentsTheme, newTheme);
};
export var dlsStandard2Theme = getDlsStandard2Theme();
export default dlsStandard2Theme;